import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { styled } from '@mui/material/styles';

const StyledEventAvailableIcon = styled(EventAvailableIcon)(({ theme }) => ({
  fontSize: '7rem',
  color: theme.palette.primary.main
}));

export default StyledEventAvailableIcon;
